// @ts-check
import RoleAnchoredRegion from "./anchored-region.js";

RoleAnchoredRegion.define();

export default RoleAnchoredRegion;
export * from "./anchored-region.js";

/**
 * @type {import("./anchored-region-globals.d.ts")}
 */
